import { createGlobalStyle } from 'styled-components';
import 'antd/dist/antd.css';

export default createGlobalStyle`

*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body{
  background: var(--background-color-sefaz);
  overflow-x: hidden;
}
#root{
  width: 100%;
  height: 100vh;
}

:root .contraste-theme {
  --font-tamanho: 12pt;

  /* --primary-color-sefaz: #FFD700; */
  --primary-color-sefaz: #FFFFFF;
  --footer-color-sefaz: var(--bottom-color-sefaz);
  --background-color-sefaz: #000000;
  --background-second-sefaz: #000000;
  --bottom-color-sefaz: #000000;
  /* --texto-color: #FFD700; */
  --texto-color: #FFFFFF;
  --cinza-color: #353535;
  --cinza-claro-color:  #A0A0A0;
  --red-color-sefaz: #C62828;


  color: var(--texto-color);

  .ant-dropdown-link{
    &[disabled] {
      color: var(--cinza-claro-color);
    }
  }

  /* MENU */
  .ant-menu-item-active {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color)
  }

  .acessibity-icon {
    filter: invert(100%);
  }

  .ant-menu-vertical {
    background-color: var(--background-second-sefaz);
    color: var(--texto-color)
  }

  /* INPUT TEXT */
  .ant-input {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);

    &[disabled] {
      color: var(--cinza-claro-color);
    }
    
    ::placeholder {
      color: var(--cinza-claro-color);
    }
  }

  /* CK EDITOR */
  .ck,
  .ck-content,
  .ck-editor__editable,
  .ck-rounded-corners,
  .ck-editor__editable_inline,
  .ck-blurred {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color)
  }

  .ck .ck-content .ck-editor__editable .ck-rounded-corners .ck-editor__editable_inline .ck-blurred{
    background-color: var(--background-color-sefaz);
    color: var(--texto-color)
  }

  /* INPUT SELECT */
  .ant-select-selector {
    background-color: var(--background-color-sefaz) !important;
  }

  .ant-select-dropdown {
    background-color: var(--background-color-sefaz);
  }

  .ant-select-item-option-disabled {
    background-color: var(--background-color-sefaz);
    color: var(--cinza-color)
  }

  .ant-select-item-option-active {
    background-color: var(--background-second-sefaz);
  }

  .ant-select-arrow {
    color: var(--primary-color-sefaz);
  }

  .ant-select-item,
  .ant-select-item-option,
  .ant-select-item-option-active,
  .ant-select-dropdown {
    color: var(--texto-color);
  }

  .ant-select-selection-item {
    background-color: transparent;
    color: var(--texto-color);
  }

  .ant-select .ant-select-selection-placeholder {
    color: var(--cinza-claro-color);
  }
  
  .ant-select-clear {
    color: var(--cinza-claro-color);
  }

  /* INPUT-DATA */
  .ant-picker,
  .ant-picker-range,
  .ant-picker-focused,
  .ant-picker-date-panel,
  .ant-picker-year-panel,
  .ant-picker-month-panel,
  .ant-picker-week-panel {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  .ant-picker-content td {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);

    &:hover {
      .ant-picker-cell-inner {
        background-color: var(--background-color-sefaz);
        color: var(--texto-color);

      }
    }
  }

  .ant-picker-cell-inner,
  .ant-picker-header {
    color: var(--texto-color);
  }

  .ant-picker-super-prev-icon,
  .ant-picker-super-next-icon,
  .ant-picker-prev-icon,
  .ant-picker-next-icon {
    color: var(--texto-color);
  }

  .ant-picker-input input {
    color: var(--texto-color);
  }

  .ant-picker-date-panel .ant-picker-content th {
    color: var(--texto-color);
  }

  .ant-picker-body {
    background-color: var(--background-color-sefaz);
  }

  .ant-picker-body th {
    color: var(--texto-color);
  }

  .ant-picker-separator, .ant-picker-suffix {
    color: var(--cinza-claro-color);
  }

  /* ICON */
  .anticon,
  svg {
    background-color: transparent;
  }

  .anticon-close-circle {
    background-color: var(--background-color-sefaz);
  }

  /* TABELA */
  .ant-table-wrapper {
    border: 2px solid var(--background-second-sefaz);
    border-radius: 5px;
  }

  .ant-table-cell {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  .ant-table-cell-row-hover {
    background-color: var(--background-second-sefaz) !important;
  }

  /* PAGINACAO */
  .ant-pagination-item,
  .ant-pagination-item-link {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color) !important;
  }

  .ant-pagination-item a {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  /* BUTTON */

  .ant-btn {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);

    &:hover {
      background-color: var(--background-second-sefaz);
      color: var(--texto-color);
    }
  }

  /* MODAL */
  .ant-modal-header,
  .ant-modal-content,
  .ant-modal-title {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  /* NOTIFICAÇÃO */
  .ant-notification-notice,
  .ant-notification-notice-message {
    background-color: var(--background-second-sefaz);
    color: var(--texto-color);
  }

  .ant-notification-notice-icon {
    background-color: var(--background-second-sefaz);
  }

  /* COMENTÁRIOS */
  .ant-comment-content-author-name,
  .ant-comment-content-author-time {
    color: var(--texto-color);
  }

  /* CARDS */
  .ant-card {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }
  .ant-card-head-title {
    color: var(--texto-color);
  }
}

:root .dark-theme {
  --font-tamanho: 12pt;

  --primary-color-sefaz: #0078bb;
  --footer-color-sefaz: var(--primary-color-sefaz);
  --background-color-sefaz: #383838;
  --background-second-sefaz: #272727;
  --bottom-color-sefaz: #3b3b3b;
  --texto-color: #FFFFFF;
  --texto-contraste-color: #070707;
  --cinza-color: #cbc8cf;
  --cinza-claro-color: #A0A0A0;
  --red-color-sefaz: #C62828;

  --grey-color-sefaz: #939BB9;
  --black-color-sefaz: #202020;

  color: var(--texto-color);

  ::placeholder {
    color: var(--cinza-claro-color);
  }

  .ant-dropdown-link{
    &[disabled] {
      color: var(--cinza-claro-color);
    }
  }

  /* MENU */
  .ant-menu-item-active {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  .acessibity-icon {
    filter: invert(100%);
  }

  .ant-menu-vertical {
    background-color: var(--background-second-sefaz);
    color: var(--texto-color);
  }

  /* INPUT TEXT */
  .ant-input {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);

    &[disabled] {
      color: var(--cinza-claro-color);
    }

    ::placeholder {
      color: var(--cinza-claro-color);
    }
  }

  #refInputTextAcessibilidade{
    background-color: transparent !important;
  }

  /* CK EDITOR */
  .ck,
  .ck-content,
  .ck-editor__editable,
  .ck-rounded-corners,
  .ck-editor__editable_inline,
  .ck-blurred {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color)
  }

  .ck .ck-content .ck-editor__editable .ck-rounded-corners .ck-editor__editable_inline .ck-blurred {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  /* INPUT SELECT */
  .ant-select-selector {
    background-color: var(--background-color-sefaz) !important;
  }

  .ant-select-dropdown {
    background-color: var(--background-color-sefaz);
  }

  .ant-select-item-option-disabled {
    background-color: var(--background-color-sefaz);
    color: var(--cinza-color);
  }

  .ant-select-item-option-active {
    background-color: var(--background-second-sefaz);
  }

  .ant-select-arrow {
    color: var(--primary-color-sefaz);
  }

  .ant-select-item,
  .ant-select-item-option,
  .ant-select-item-option-active,
  .ant-select-dropdown {
    color: var(--texto-color);
  }

  .ant-select-selection-item {
    background-color: transparent;
    color: var(--cinza-color);
  }

  .ant-select.ant-select-selection-placeholder {
    color: var(--cinza-claro-color);
  }

  .ant-select-clear {
    color: var(--cinza-claro-color);
  }

  /* INPUT-DATA */
  .ant-picker,
  .ant-picker-range,
  .ant-picker-focused,
  .ant-picker-date-panel,
  .ant-picker-year-panel,
  .ant-picker-month-panel,
  .ant-picker-week-panel {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  .ant-picker-content td {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);

    &:hover {
      .ant-picker-cell-inner {
        background-color: var(--background-color-sefaz);
        color: var(--texto-color);

      }
    }
  }

  .ant-picker-cell-inner,
  .ant-picker-header {
    color: var(--texto-color);
  }

  .ant-picker-super-prev-icon,
  .ant-picker-super-next-icon,
  .ant-picker-prev-icon,
  .ant-picker-next-icon {
    color: var(--texto-color);
  }

  .ant-picker-input input {
    color: var(--texto-color);
  }

  .ant-picker-date-panel .ant-picker-content th {
    color: var(--texto-color);
  }

  .ant-picker-body {
    background-color: var(--background-color-sefaz);
  }

  .ant-picker-body th {
    color: var(--texto-color);
  }

  .ant-picker-separator, .ant-picker-suffix {
    color: var(--cinza-claro-color);
  }

  /* ICON */
  .anticon,
  svg {
    background-color: transparent;
  }

  .anticon-close-circle {
    background-color: var(--background-color-sefaz);
  }

  /* TABELA */
  .ant-table-wrapper {
    border: 2px solid var(--background-second-sefaz);
    border-radius: 5px;
  }

  .ant-table-cell {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  .ant-table-cell-row-hover {
    background-color: var(--background-second-sefaz) !important;
  }

  /* PAGINACAO */
  .ant-pagination-item,
  .ant-pagination-item-link {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color) !important;
  }

  .ant-pagination-item a {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  /* BUTTON */

  .ant-btn {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);

    &:hover {
      background-color: var(--background-second-sefaz);
      color: var(--texto-color);
    }
  }

  /* MODAL */
  .ant-modal-header,
  .ant-modal-content,
  .ant-modal-title {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }

  /* NOTIFICAÇÃO */
  .ant-notification-notice,
  .ant-notification-notice-message {
    background-color: var(--background-second-sefaz);
    color: var(--texto-color);
  }

  .ant-notification-notice-icon {
    background-color: var(--background-second-sefaz);
  }

  /* COMENTÁRIOS */
  .ant-comment-content-author-name,
  .ant-comment-content-author-time {
    color: var(--texto-color);
  }

  /* CARDS */
  .ant-card {
    background-color: var(--background-color-sefaz);
    color: var(--texto-color);
  }
  .ant-card-head-title {
    color: var(--texto-color);
  }
}

@media (min-width: 700px){
  :root{
      font-size: 62.5%;
  }
}
`;
